import { Box, Text } from "@chakra-ui/react";
import { NewPageLink } from "../Common/NewPageLink";
import Font, { FontDecoration, Spacing } from "../Utils/Calligraphy";
import { Urls, UrlsLicenses } from "../Utils/Strings";

const SectionFontsUrlsBox = () => {
  return (
    <>
      <Box flexDirection="row" display="flex">
        <Text
          fontFamily={Font.Medium}
          textAlign={Spacing.TextAlignCenter}
        >{`Fonts from:`}</Text>
        <Box w="4px" />
        <Text
          fontFamily={Font.MediumItalic}
          decoration={FontDecoration.Underline}
          textAlign={Spacing.TextAlignCenter}
        >
          <NewPageLink href={Urls.Fontshare} text="fontshare.com" />
        </Text>
      </Box>

      <Box flexDirection="row" display="flex">
        <Text
          fontFamily={Font.MediumItalic}
          decoration={FontDecoration.Underline}
          textAlign={Spacing.TextAlignCenter}
        >
          <NewPageLink href={Urls.FontshareSatoshiFont} text="Satoshi" /> |
          License:{" "}
          <NewPageLink
            href={UrlsLicenses.ITFFFL}
            text="ITF Free Font License (FFL)"
          />
        </Text>
      </Box>
    </>
  );
};

export default SectionFontsUrlsBox;
